/**
    * Bone description
    * (c) lg2fabrique 2017
*/
import { Assets } from '../core/Assets';
import { autobind } from 'frontools/decorators/Autobind';
import GameTimer from '../core/components/GameTimer';
import { Titubetibia } from './Titubetibia';
import NumberUtils from 'frontools/utils/NumberUtils';
import ComponentAbstract from '../core/components/ComponentAbstract';

export default class Bone extends ComponentAbstract {
    
    private _game                           : Titubetibia   = Titubetibia.instance;
    
    private _sprite                         : PIXI.extras.AnimatedSprite;
   
    private _container                      : PIXI.Container;
    
    private _startIndex                     : number;
    private _actualFrame                    : number;
    private _startingFrame                  : number;
    private _scoreBracketHigherLeft         : number;
    private _scoreBracketHigherRight        : number;
    private _scoreBracketLowerLeft          : number;
    private _scoreBracketLowerRight         : number

    private _direction                      : number;
    private _randomFlip                     : number;
    
    private _arms                           : PIXI.extras.AnimatedSprite;
    private _armsPosition                   : object[];

    private _time                           : number                        = 0;
    private _closeChrono                    : number                        = 10;
    private _soundChrono                    : number                        = 3000;

    private _score                          : number

    constructor(private _config: ILevelConfig) {
        super();

        this._container = new PIXI.Container();

        this._sprite = this.getSpriteFromImg(this._config.character);

        this._startingFrame = Math.ceil(this._sprite.totalFrames / 2);
        this._actualFrame = this._startingFrame;
        this._scoreBracketHigherLeft =  Math.ceil(this._sprite.totalFrames / 2.5);
        this._scoreBracketHigherRight =  Math.ceil(this._sprite.totalFrames / 1.7);
        this._scoreBracketLowerLeft = 12;
        this._scoreBracketLowerRight = 51;

        this._sprite.gotoAndStop(this._startingFrame);
        this._container.addChild(this._sprite);  

        this._arms = Assets.getSpriteFromJson('arms') as PIXI.extras.AnimatedSprite;
        this._container.addChild(this._arms);
        this._arms.pivot.x = this._arms.width / 2;
        
        this._armsPosition = [
            { x: this._container.width / 2 - this._arms.width / .93,  y: this._container.height / 2 - this._arms.height / 3.5,  speed: 2,   rot: -45}, 
            { x: this._container.width / 2 - this._arms.width / .94,  y: this._container.height / 2 - this._arms.height / 3.3,  speed: 2,   rot: -45}, 
            { x: this._container.width / 2 - this._arms.width / .95,  y: this._container.height / 2 - this._arms.height / 3.1,  speed: 2,   rot: -45},
            { x: this._container.width / 2 - this._arms.width / .96,  y: this._container.height / 2 - this._arms.height / 2.9,  speed: 2,   rot: -45},
            { x: this._container.width / 2 - this._arms.width / .97,  y: this._container.height / 2 - this._arms.height / 2.7,  speed: 2,   rot: -45},
            
            { x: this._container.width / 2 - this._arms.width / .98,  y: this._container.height / 2 - this._arms.height / 2.65, speed: 1.6, rot: -45}, 
            { x: this._container.width / 2 - this._arms.width / .99,  y: this._container.height / 2 - this._arms.height / 2.6,  speed: 1.6, rot: -45},
            { x: this._container.width / 2 - this._arms.width,        y: this._container.height / 2 - this._arms.height / 2.5,  speed: 1.6, rot: -45},
            { x: this._container.width / 2 - this._arms.width / 1.01, y: this._container.height / 2 - this._arms.height / 2.4,  speed: 1.6, rot: -45},
            { x: this._container.width / 2 - this._arms.width / 1.02, y: this._container.height / 2 - this._arms.height / 2.3,  speed: 1.6, rot: -45},

            { x: this._container.width / 2 - this._arms.width / 1.03, y: this._container.height / 2 - this._arms.height / 2.2,  speed: 1.6, rot: -45},
            { x: this._container.width / 2 - this._arms.width / 1.04, y: this._container.height / 2 - this._arms.height / 2.1,  speed: 1.6, rot: -45},
            { x: this._container.width / 2 - this._arms.width / 1.16, y: this._container.height / 2 - this._arms.height / 1.7,  speed: 1.3, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.19, y: this._container.height / 2 - this._arms.height / 1.62, speed: 1.3, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.21, y: this._container.height / 2 - this._arms.height / 1.6,  speed: 1.3, rot: -7},

            { x: this._container.width / 2 - this._arms.width / 1.23, y: this._container.height / 2 - this._arms.height / 1.58, speed: 1.3, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.25, y: this._container.height / 2 - this._arms.height / 1.54, speed: 1.3, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.27, y: this._container.height / 2 - this._arms.height / 1.52, speed: 1.1, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.3,  y: this._container.height / 2 - this._arms.height / 1.5,  speed: 1.1, rot: -7},
            { x: this._container.width / 2 - this._arms.width / 1.7,  y: this._container.height / 2 - this._arms.height / 1.32, speed: 1.1, rot: -19},

            { x: this._container.width / 2 - this._arms.width / 1.75, y: this._container.height / 2 - this._arms.height / 1.31, speed: 1.1, rot: -19},
            { x: this._container.width / 2 - this._arms.width / 1.8,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: 1.1, rot: -19},
            { x: this._container.width / 2 - this._arms.width / 2.15, y: this._container.height / 2 - this._arms.height / 1.32, speed: .8,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.25, y: this._container.height / 2 - this._arms.height / 1.31, speed: .8,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.35, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .8,  rot: 0},

            { x: this._container.width / 2 - this._arms.width / 2.45, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .6,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.5,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: .6,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.55, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .6,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.65, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.75, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},

            { x: this._container.width / 2 - this._arms.width / 2.85, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 2.95, y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},    
            
            { x: this._container.width / 2 - this._arms.width / 3,    y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},     // middle
        
            { x: this._container.width / 2 - this._arms.width / 3.1,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0}, 
            { x: this._container.width / 2 - this._arms.width / 3.3,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},
            
            { x: this._container.width / 2 - this._arms.width / 3.5,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 3.7,  y: this._container.height / 2 - this._arms.height / 1.3,  speed: .5,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 3.9,  y: this._container.height / 2 - this._arms.height / 1.31, speed: .6,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 4.1,  y: this._container.height / 2 - this._arms.height / 1.32, speed: .6,  rot: 0},
            { x: this._container.width / 2 - this._arms.width / 4.3,  y: this._container.height / 2 - this._arms.height / 1.33, speed: .6,  rot: 0},

            { x: this._container.width / 2 + this._arms.width / 50,   y: this._container.height / 2 - this._arms.height / 1.62, speed: .8,  rot: 7},
            { x: this._container.width / 2 + this._arms.width / 30,   y: this._container.height / 2 - this._arms.height / 1.64, speed: .8,  rot: 7},
            { x: this._container.width / 2 + this._arms.width / 20,   y: this._container.height / 2 - this._arms.height / 1.66, speed: .8,  rot: 7},
            { x: this._container.width / 2 + this._arms.width / 15,   y: this._container.height / 2 - this._arms.height / 1.68, speed: 1.1, rot: 7},   
            { x: this._container.width / 2 + this._arms.width / 12,   y: this._container.height / 2 - this._arms.height / 1.7,  speed: 1.1, rot: 7},
            
            { x: this._container.width / 2 + this._arms.width / 11,   y: this._container.height / 2 - this._arms.height / 1.72, speed: 1.1, rot: 7},
            { x: this._container.width / 2 + this._arms.width / 10,   y: this._container.height / 2 - this._arms.height / 1.74, speed: 1.1, rot: 7},
            { x: this._container.width / 2 + this._arms.width / 9,    y: this._container.height / 2 - this._arms.height / 1.76, speed: 1.3, rot: 7},
            { x: this._container.width / 2 + this._arms.width / 4.4,  y: this._container.height / 2 - this._arms.height / 2.35, speed: 1.3, rot: 20},            
            { x: this._container.width / 2 + this._arms.width / 4.2,  y: this._container.height / 2 - this._arms.height / 2.45, speed: 1.3, rot: 20},
            
            { x: this._container.width / 2 + this._arms.width / 4,    y: this._container.height / 2 - this._arms.height / 2.5,  speed: 1.3, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 3.8,  y: this._container.height / 2 - this._arms.height / 2.55, speed: 1.3, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 3.6,  y: this._container.height / 2 - this._arms.height / 2.6,  speed: 1.3, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 3.4,  y: this._container.height / 2 - this._arms.height / 2.65, speed: 1.3, rot: 20},            
            { x: this._container.width / 2 + this._arms.width / 3.2,  y: this._container.height / 2 - this._arms.height / 2.7,  speed: 1.6, rot: 20},
            
            { x: this._container.width / 2 + this._arms.width / 3.1,  y: this._container.height / 2 - this._arms.height / 2.75, speed: 1.6, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 3,    y: this._container.height / 2 - this._arms.height / 2.9,  speed: 1.6, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 2.9,  y: this._container.height / 2 - this._arms.height / 3,    speed: 1.6, rot: 20},
            { x: this._container.width / 2 + this._arms.width / 2.8,  y: this._container.height / 2 - this._arms.height / 7.2,  speed: 1.6,   rot: 33},         
            { x: this._container.width / 2 + this._arms.width / 2.3,  y: this._container.height / 2 - this._arms.height / 7.5,  speed: 2,   rot: 33},
            
            { x: this._container.width / 2 + this._arms.width / 2.25, y: this._container.height / 2 - this._arms.height / 7.8,  speed: 2,   rot: 33},
            { x: this._container.width / 2 + this._arms.width / 2.2,  y: this._container.height / 2 - this._arms.height / 8,    speed: 2,   rot: 33},
            { x: this._container.width / 2 + this._arms.width / 2.2,  y: this._container.height / 2 - this._arms.height / 8,    speed: 2,   rot: 33},
            { x: this._container.width / 2 + this._arms.width / 2.2,  y: this._container.height / 2 - this._arms.height / 8,    speed: 2,   rot: 33}

        ]

        this._arms.x = this._armsPosition[this._startingFrame]['x'];
        this._arms.y = this._armsPosition[this._startingFrame]['y'];
        this._arms.animationSpeed = this._armsPosition[this._startingFrame]['speed'];
        this._arms.rotation = this._armsPosition[this._startingFrame]['rot'];
        this._arms.play();

        this._game.addListener('gameOver', this._stopSounds);
    };

    public getSpriteFromImg(name: string) {
        var frames = [],
            frameCount = this._config.framesCount;

        for (var i = 1, l = frameCount; i <= l ; i++) {
            frames.push(Assets.getRessource(name + i));
        }
        return new PIXI.extras.AnimatedSprite(frames);
    };


    public timer() {
        setTimeout(function() {
            this._time++;
            this.timer();
        }.bind(this), 10);
    }

    
    public boneFall() {
        setTimeout(function() {
            if (this._actualFrame == this._startingFrame) this._boneDirection();
           
            if (this._time > 60)  {
                this._randomFlip = Math.floor((Math.random() * 10) + 1);
                if(this._randomFlip == 5) {
                    if (this._direction == 1) this._direction = 2;
                    else this._direction = 1;
                }
            }

            if (this._direction == 1) this._actualFrame--;
            else this._actualFrame++;

            if (this._actualFrame > 0 && this._actualFrame < this._sprite.totalFrames && this._game.gameOn) {
                this._sprite.gotoAndStop(this._actualFrame);
                this.boneFall();
            } else {
                this._onReachEnd();
            }

            let mobileAcceleration = 0;
            if (window.devicePixelRatio > 1) mobileAcceleration = 25;   

            if (this._time > 10) this._closeChrono = 15;
            if (this._time > 20) this._closeChrono = 30;
            if (this._time > 30) this._closeChrono = 300- mobileAcceleration;
            if (this._time > 500) this._closeChrono = 200- mobileAcceleration;
            if (this._time > 1000) { 
                this._closeChrono = 150 - mobileAcceleration; 
                this._scoreBracketLower =  Math.ceil(this._sprite.totalFrames / 3);
                this._scoreBracketHigher =  Math.ceil(this._sprite.totalFrames / 1.5);
            }
            if (this._time > 1500) this._closeChrono = 100- mobileAcceleration;
            
            if (this._game.gameOn)
                if (this._actualFrame == 1 || this._actualFrame == 63) Assets.sounds['fallen1'].play();
            
            this._game._updateGlasses();
            this._armsFollowSprite();

        }.bind(this), this._closeChrono);
    }
    

    private _boneDirection() {
        this._direction = Math.floor((Math.random() * 2) + 1);
        return this._direction;
    }


    public moveLeft() {
        this._actualFrame--;
        this._sprite.gotoAndStop(this._actualFrame);
        this._armsFollowSprite();
    }


    public moveRight() {
        this._actualFrame++;
        this._sprite.gotoAndStop(this._actualFrame);
        this._armsFollowSprite();
    }


    private _armsFollowSprite() {
        this._arms.x = this._armsPosition[this._actualFrame]['x'];
        this._arms.y = this._armsPosition[this._actualFrame]['y'];
        this._arms.animationSpeed = this._armsPosition[this._actualFrame]['speed'];
        this._arms.rotation = this._armsPosition[this._actualFrame]['rot'];
    }


    public playSounds() {
        if (this._game.gameOn) {
            if (this._actualFrame > this._scoreBracketHigherLeft && this._actualFrame < this._scoreBracketHigherRight) {
                Assets.sounds['pfiou' + NumberUtils.random(1, 5)].play();
                this._soundChrono = 1300;
            } else {
                let soundIndex = NumberUtils.random(1, 4)
                Assets.sounds['falling' + soundIndex].play();
                if (soundIndex == 1) this._soundChrono = 1500;
                if (soundIndex == 2) this._soundChrono = 3500;
                if (soundIndex == 3 || soundIndex == 4) this._soundChrono = 8500;
            }
            
            setTimeout(function() {
                this.playSounds();
            }.bind(this), this._soundChrono);
        }
    }

    private _onReachEnd() {
        this.dispatch({type:'reachend'});
        this._stopSounds();
    }

    private _stopSounds() {
        Assets.sounds['pfiou1'].stop();
        Assets.sounds['pfiou2'].stop();
        Assets.sounds['pfiou3'].stop();
        Assets.sounds['pfiou4'].stop();
        Assets.sounds['pfiou5'].stop();
        Assets.sounds['falling1'].stop();
        Assets.sounds['falling2'].stop();
        Assets.sounds['falling3'].stop();
        Assets.sounds['falling4'].stop();
        Assets.sounds['fallen1'].stop();
    }


    public get container(): PIXI.Container {
        return this._container;
    }

    public get actualFrame(): number {
        return this._actualFrame;
    }

    public get score(): number {
        if (this._actualFrame > this._scoreBracketHigherLeft && this._actualFrame < this._scoreBracketHigherRight)
            this._score = 2;
        else if (this._actualFrame > this._scoreBracketLowerLeft && this._actualFrame <= this._scoreBracketHigherLeft || this._actualFrame >= this._scoreBracketHigherRight && this._actualFrame < this._scoreBracketLowerRight)
            this._score = 1;
        else 
            this._score = 0;
        
        return this._score;
    }

    public get config(): ILevelConfig {
        return this._config;
    };
}


export interface ILevelConfig {
    character: string;
    framesCount: number;
}